import {format} from "date-fns";
import React, {Component} from "react";
import DatePicker from "react-datepicker";
import {connect} from "react-redux";
import {AccountHeads, NewInventoryProduct,} from "../../../../redux/actions/Modules.Action";
import ApiConnect from "../../../../Utils/ApiConnect";
import AutoComplete from "../../../Components/AutoComplete";
import ReportTable from "./ReportTable";
import Statistics from "./Statistics";

const date = new Date();
class SalesReport extends Component {
  constructor(props) {
    super(props);
    this.state = {
      startDate: new Date(
        date.getFullYear(),
        date.getMonth() - 1,
        date.getDay()
      ),
      endDate: new Date(),
      salesData: false,
      fetchData: false,
      account: "",
      route: "",
      product: "",
    };
  }

  onChange = (dates) => {
    const [start, end] = dates;
    this.setState({ startDate: start, endDate: end });
  };

  fetchSalesData() {
    ApiConnect.get(`/Module/SalesPurchase/Sales/SalesData`)
      .then((response) => {
        this.setState({ salesData: response.data });
        this.props.AccountHeads(response.data.account);
        this.props.NewInventoryProduct(response.data.products.product);
      })
      .catch((error) => console.log(error));
  }
  autoCompleteAction = (e) => {
    this.setState({ account: e.id });
  };
  productAutocomplete = (e) => {
    this.setState({ product: e.id });
  };
  handleReset() {
    this.setState({
      account: "",
      route: "",
      product: "",
      startDate: new Date(
        date.getFullYear(),
        date.getMonth() - 1,
        date.getDay()
      ),
      endDate: new Date(),
    });
  }
  componentDidMount = () => {
    this.fetchSalesData();
  };
  fetchData = () => {
    try {
      ApiConnect.get(
        `/Module/SalesPurchase/Sales/Report?from=${
          this.state.startDate ? format(this.state.startDate, "yyyy-MM-dd") : ""
        }&to=${
          this.state.endDate ? format(this.state.endDate, "yyyy-MM-dd") : ""
        }&account=${this.state.account}&route=${this.state.route}&product=${
          this.state.product
        }&limit`
      )
        .then((response) => {
          this.setState({ fetchData: response.data });
        })
        .catch((err) => console.error(err));
    } catch (err) {
      console.log("error facing location:", err);
    }
  };

  render() {
    const salesData = this.state.salesData;
    const Accounts = this.props.accountHead;
    const productList = this.props.productList;
    return (
      <>
        {" "}
        <div className="card">
          <div className="card-title">
            <h2 className="col-4">Sales Report</h2>
            <div className="row">
              <div className="col-3 form-group">
                <label>Account Head</label>
                {Accounts.length !== 0 ? (
                  <AutoComplete
                    name="accounthead"
                    action={this.autoCompleteAction}
                    placeHolder="Account Head"
                    styleName=""
                    items={Accounts}
                  />
                ) : (
                  ""
                )}
              </div>
              <div className="col-3 form-group">
                <label>Product</label>
                {productList.length !== 0 ? (
                  <AutoComplete
                    name="productname"
                    action={this.productAutocomplete}
                    placeHolder="Product Search"
                    styleName=""
                    items={productList}
                  />
                ) : (
                  ""
                )}
              </div>
              <div className="col-2 form-group">
                <label>Route</label>
                <select
                  className="form-control"
                  onChange={(e) => this.setState({ route: e.target.value })}
                >
                  <option value={""}>All Routes</option>
                  {salesData
                    ? salesData.route.map((rt, index) => (
                        <option key={index} value={rt.id}>
                          {rt.name}
                        </option>
                      ))
                    : ""}
                </select>
              </div>
              <div className="col-2 form-group">
                <label>Date Range</label>
                <DatePicker
                  selected={this.state.startDate}
                  onChange={this.onChange}
                  startDate={this.state.startDate}
                  endDate={this.state.endDate}
                  maxDate={new Date()}
                  excludeDates={[(new Date(), 1), (new Date(), 5)]}
                  selectsRange
                  selectsDisabledDaysInRange
                  className="form-control"
                />
              </div>
              <div className="col-2 form-group">
                <button
                  className="btn btn-secondary col"
                  onClick={() => {
                    this.handleReset();
                  }}
                >
                  Reset
                </button>
                <button
                  className="btn btn-primary col"
                  onClick={() => this.fetchData()}
                >
                  Fetch
                </button>
              </div>
            </div>
          </div>
        </div>
        {this.state.fetchData ? (
          <>
            <Statistics data={this.state.fetchData} type="sales" />
            <ReportTable data={this.state.fetchData.ProductData} type="sales" />
          </>
        ) : (
          ""
        )}
      </>
    );
  }
}

export default connect(
  (state) => ({
    accountHead: state.Accounts.AccountHead,
    productList: state.Inventory.Products,
  }),
  { AccountHeads, NewInventoryProduct }
)(SalesReport);
